import React, {
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import {Icon} from "antd";
import {useLocation} from "react-router-dom";
import i18n from "../../i18n";
import {
  prefersReducedMotion,
} from "../../presentation/public-site/motion-preference";

function ScrollNavigation() {
  const location = useLocation();
  const [scrollPosition, setScrollPosition] = useState(window.pageYOffset);
  const [returnPosition, setReturnPosition] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.pageYOffset);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, {passive: true});

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useLayoutEffect(() => {
    if (location.hash) {
      return;
    }

    window.scrollTo(0, 0);
    setScrollPosition(0);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    setReturnPosition(null);
  }, [location.pathname, location.search]);

  const scrollToTop = () => {
    if (window.pageYOffset <= 0) {
      return;
    }

    setReturnPosition(window.pageYOffset);

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion()
        ? "auto"
        : "smooth",
    });
  };

  const scrollToReturnPosition = () => {
    if (returnPosition === null) {
      return;
    }

    window.scrollTo({
      top: returnPosition,
      behavior: prefersReducedMotion()
        ? "auto"
        : "smooth",
    });

    setReturnPosition(null);
  };

  const isToTopVisible = scrollPosition > 300;
  const isReturnVisible = returnPosition !== null
    && scrollPosition < returnPosition - 100;

  if (!isToTopVisible && !isReturnVisible) {
    return null;
  }

  return (
    <div className="scroll-navigation">
      {isReturnVisible && (
        <button
          type="button"
          className="scroll-navigation__button scroll-navigation__button--return"
          onClick={scrollToReturnPosition}
          title={i18n.t("main.scrollNavigation.return")}
          aria-label={i18n.t("main.scrollNavigation.return")}
        >
          <Icon type="rollback"/>
        </button>
      )}

      {isToTopVisible && (
        <button
          type="button"
          className="scroll-navigation__button"
          onClick={scrollToTop}
          title={i18n.t("main.scrollNavigation.toTop")}
          aria-label={i18n.t("main.scrollNavigation.toTop")}
        >
          <Icon type="arrow-up"/>
        </button>
      )}
    </div>
  );
}

export default ScrollNavigation;
